import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Redirect } from "react-router-dom";
import TopBar from "../components/TopBar";
import Sidebar from "../components/Sidebar";
import RaboChat from "../components/RaboAI/RaboChat";
import FileList from "../components/RaboAI/FileList"; // Import FileList component

function AIPage(props) {
    const { token } = props;

    // State to hold uploaded file titles
    const [uploadedFiles, setUploadedFiles] = useState([]);

    // Fetch files on component mount
    useEffect(() => {
        const fetchFiles = async () => {
            try {
                const response = await fetch("https://api.demo1.raborisk.ai /api/upload");
                if (response.ok) {
                    const files = await response.json();
                    const fileMappings = files.map((storedName) => ({
                        storedName,
                        originalName: storedName.substring(storedName.indexOf("-") + 1), // Extract original name
                    }));
                    setUploadedFiles(fileMappings);
                } else {
                    console.error("Failed to fetch files:", response.statusText);
                }
            } catch (error) {
                console.error("Error fetching files:", error);
            }
        };

        fetchFiles();
    }, []);

    // Handle file upload
    const handleFileUpload = async (e) => {
        const file = e.target.files[0];
        if (file) {
            const formData = new FormData();
            formData.append("file", file);

            try {
                const response = await fetch("https://api.demo1.raborisk.ai /api/upload", {
                    method: "POST",
                    body: formData,
                });

                if (response.ok) {
                    const data = await response.json();
                    setUploadedFiles((prevFiles) => [
                        ...prevFiles,
                        { storedName: data.storedName, originalName: data.originalName },
                    ]);
                } else {
                    console.error("Failed to upload file:", response.statusText);
                }
            } catch (err) {
                console.error("Error uploading file:", err);
            }
        }
    };

    const handleDeleteFile = async (storedName) => {
        try {
            const response = await fetch(`https://api.demo1.raborisk.ai /api/upload/${storedName}`, {
                method: "DELETE",
            });

            if (response.ok) {
                setUploadedFiles((prevFiles) =>
                    prevFiles.filter((file) => file.storedName !== storedName)
                );
            } else {
                console.error("Failed to delete file");
            }
        } catch (error) {
            console.error("Error deleting file:", error);
        }
    };

    return token ? (
        <div className="flex flex-col w-full h-screen overflow-hidden">
            <TopBar className="fixed top-0 left-0 right-0 z-10" />
            <div className="flex flex-row w-full h-full">
                <Sidebar className="fixed top-0 left-0 h-screen pt-[64px] z-0" />
                <div className="flex flex-row w-full h-full">
                    {/* File List Component */}
                    <FileList
                        uploadedFiles={uploadedFiles}
                        setUploadedFiles={setUploadedFiles}
                        handleFileUpload={handleFileUpload}
                        handleDeleteFile={handleDeleteFile}
                    />
                    {/* Chat Section */}
                    <div className="flex-grow">
                        <RaboChat onFileUpload={() => {}} />
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <Redirect to="/login" />
    );
}

const mapStateToProps = (state) => {
    return {
        token: state.auth.token,
    };
};

export default compose(connect(mapStateToProps))(AIPage);
